<template>
  <footer class="footer">
    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="ctaContent">
          <div class="logoWrapper">
            <img
              :src="require('@/assets/images/logo.png')"
              alt="KisiAI"
              width="64"
              height="64"
              class="ctaLogo"
            />
          </div>
          <h2>为全球市场发布视频</h2>
          <button class="primaryButton" @click="handleStart">免费使用</button>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="footerContent">
        <div class="footerSection">
          <h3>AI工具</h3>
          <ul>
            <li><router-link to="/video-translation">视频翻译</router-link></li>
            <li><router-link to="/video-swapping">视频换脸</router-link></li>
            <li><router-link to="/sound-cloning">音色克隆</router-link></li>
          </ul>
        </div>
        
        <div class="footerSection">
          <h3>产品</h3>
          <ul>
            <li><router-link to="/pricing">定价</router-link></li>
          </ul>
        </div>
        
        <div class="footerSection">
          <h3>关于</h3>
          <ul>
            <li><a href="/terms_of_service.html">用户协议</a></li>
            <li><a href="/privacy_policy.html">隐私政策</a></li>
          </ul>
        </div>
      </div>
      
      <div class="footerBottom">
        <div class="logo">
          <img
            :src="require('@/assets/images/logo.png')"
            alt="KisiAI"
            width="24"
            height="24"
          />
        </div>
        <div class="copyright">
          © {{ new Date().getFullYear() }} KisiAI. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { handleStart } from '@/utils/navigation'

export default {
  name: 'Footer',
  methods: {
    handleStart() {
      handleStart(this.$router, this.$store)
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #F9FAFB;
  padding: 64px 0 32px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footerContent {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 64px;
  margin-bottom: 64px;
}

.footerSection h3 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.footerSection ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footerSection li {
  margin-bottom: 12px;
}

.footerSection a {
  color: #6B7280;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footerSection a:hover {
  color: #111827;
}

.footerBottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  border-top: 1px solid #E5E7EB;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo img {
  height: 24px;
}

.betaTag {
  font-size: 12px;
  padding: 2px 8px;
  background-color: #6366F1;
  color: white;
  border-radius: 4px;
}

.copyright {
  color: #6B7280;
  font-size: 14px;
}

/* CTA Section */
.cta {
  padding: 80px 0;
  text-align: center;
  background: #F9FAFB;
}

.ctaContent {
  max-width: 600px;
  margin: 0 auto;
}

.logoWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.ctaLogo {
  width: 64px !important;
  height: 64px !important;
}

.logoWrapper span {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.02em;
}

.cta h2 {
  font-size: 36px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 32px;
}

.primaryButton {
  padding: 14px 32px;
  background: #6366F1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.primaryButton:hover {
  background: #4F46E5;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .footer {
    padding: 48px 0 24px;
  }

  .footerContent {
    grid-template-columns: 1fr;
    gap: 32px;
    margin-bottom: 48px;
  }

  .footerBottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}
</style> 